import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getProjectTenderDetailList, getProjectTenderSowTemplateList, getSowPriliminaryData, getSowSectionAndPriliminary, getSowSectionData } from "../Thunks/tenderThunks";
import { ProjectTenderDetailInterface, TenderDocumentInterface, TenderListInterface } from "../Types/Tender/projectTenderDetailsInterface";
import { mapShareContactDetails, ShareContact, ShareContactDetails, ShareContactDetailsPayload } from "../Types/Project/ShareContactInterface";
import { Priliminary, SectionAndPriliminaryType, SowSection, TenderSow } from "../Types/Tender/tenderSow";
import { ProjectBasicContact } from "../Types/Project/ProjectInterface";

interface TenderState {
    projectTenderDetail: ProjectTenderDetailInterface[];
    loadingProjectTenderDetail: boolean;
    errorProjectTenderDetail: string | null;

    projectAllContact: ProjectBasicContact[];

    sharedContacttDetailList: ShareContactDetails[];
    filteredContacttDetailList: ShareContactDetails[];

    currentProjectTenderPartId: number;
    tenderDocumentListForView: TenderDocumentInterface[];

    tenderSowTemplateList: TenderSow[];
    loadingProjectTenderSow: boolean;
    errorProjectTenderSow: string | null;

    currentProjectTenderDetail?: ProjectTenderDetailInterface | null;

    viewSowSection: SowSection[];
    loadingViewSowSection: boolean;
    errorViewSowSection: string | null;

    viewSowPriliminary: Priliminary[];
    loadingViewSowPriliminary: boolean;
    errorViewSowPriliminary: string | null;

    loadingViewSowSectionAndPriliminary: boolean;
    errorViewSowSectionAndPriliminary: string | null;

    contactListForComparePrice:TenderListInterface[];

   
    
    
}

const initialState: TenderState = {
    projectTenderDetail: [],
    loadingProjectTenderDetail: false,
    errorProjectTenderDetail: null,
    projectAllContact: [],
    sharedContacttDetailList: [],
    filteredContacttDetailList: [],
    currentProjectTenderPartId: 0,
    tenderDocumentListForView: [],

    tenderSowTemplateList: [],
    loadingProjectTenderSow: false,
    errorProjectTenderSow: null,

    currentProjectTenderDetail:null,

    viewSowSection: [],
    loadingViewSowSection: false,
    errorViewSowSection: null,

    viewSowPriliminary: [],
    loadingViewSowPriliminary: false,
    errorViewSowPriliminary: null,

    loadingViewSowSectionAndPriliminary: false,
    errorViewSowSectionAndPriliminary: null,

    contactListForComparePrice: [],
    
}

const tenderSlice = createSlice ({
    name: 'tender',
    initialState,
    reducers : {
      setSharedContactDetails : (state, action: PayloadAction<{sharedContact: ShareContact[], projctAllContact : ProjectBasicContact[]}>) => {
        const { sharedContact, projctAllContact } = action.payload;

        state.projectAllContact = projctAllContact;

        const sharedContacttDetailList: ShareContactDetails[] = projctAllContact &&  projctAllContact.map((contactDet) => {

          if (contactDet) {
            const contDet: any = {
              by: contactDet.by,
              id: contactDet.id,
              folder_id: 0,
              first_name: contactDet.first_name,
              last_name: contactDet.last_name,
              profile_image: contactDet.profile_image,
              mobile: contactDet.mobile,
              landline: contactDet.landline,
              email: contactDet.email,
              address: contactDet.address,
              city: contactDet.city,
              post_code: contactDet.post_code,
              role_name: contactDet.role_name,
              isCheckedForShare: false,
              isCheckedForEdit: false,
              isCheckedForView: false,
            };
          return   mapShareContactDetails(contDet)
            
          } else{
            
            const emptyData: any =  {
              by: 0,
              id: 0,
              folder_id: 0,
              first_name: '',
              last_name: '',
              profile_image: '',
              mobile: '',
              landline: '',
              email: '',
              address: '',
              city: '',
              post_code: '',
              role_name: '',
              isCheckedForShare: false,
              isCheckedForEdit: false,
              isCheckedForView: false,
            };

            return   mapShareContactDetails(emptyData)
          }
      
          
          
        });


        state.sharedContacttDetailList = sharedContacttDetailList;
        state.filteredContacttDetailList = state.sharedContacttDetailList;

      },

      setFilterContact : (state, action: PayloadAction<string>) => {
        const userType = action.payload;

        if (userType === null) {
          state.filteredContacttDetailList = state.sharedContacttDetailList;
        } else if (userType === "Professional") {
          state.filteredContacttDetailList = state.sharedContacttDetailList.filter(
            (e) =>
              e.by.toLowerCase() === "company" ||
              e.by.toLowerCase() === "self employee"
          )
        } else if (userType === "Client") {
         
            state.filteredContacttDetailList = state.sharedContacttDetailList.filter(
              (e) =>
                e.by.toLowerCase() === "commercial client" ||
                e.by.toLowerCase() === "domestic client"
            )
          
        } else if (userType === "Employee") {
          
            state.filteredContacttDetailList = state.sharedContacttDetailList.filter(
              (e) => e.by.toLowerCase() === "employee"
            )
         
        }
      
      },
      setCheckSharedContact : (state, action: PayloadAction<ShareContactDetailsPayload>) => {
        
        const contact = state.sharedContacttDetailList.find(
          (contact) => contact.id === action.payload.id
        );
        if (contact) {
          contact.isCheckedForShare = action.payload.isChecked; // Update the `isChecked` status

          if(!action.payload.isChecked){
            contact.isCheckedForEdit = false;
            contact.isCheckedForView = false;
          }
        }

      },
      setCheckSharedContactEdit : (state, action: PayloadAction<ShareContactDetailsPayload>) => {

        const contact = state.sharedContacttDetailList.find(
          (contact) => contact.id === action.payload.id
        );
        if (contact) {
          contact.isCheckedForEdit = action.payload.isChecked; // Update the `isChecked` status
         
        }

        const contactFiltered = state.filteredContacttDetailList.find(
          (contact) => contact.id === action.payload.id
        );
        if (contactFiltered) {
          contactFiltered.isCheckedForEdit = action.payload.isChecked; // Update the `isChecked` status
         
        }

      },
      setCheckSharedContactView : (state, action: PayloadAction<ShareContactDetailsPayload>) => {

        const contact = state.sharedContacttDetailList.find(
          (contact) => contact.id === action.payload.id
        );
        if (contact) {
          contact.isCheckedForView = action.payload.isChecked; // Update the `isChecked` status
        }

        const contactFiltered = state.filteredContacttDetailList.find(
          (contact) => contact.id === action.payload.id
        );
        if (contactFiltered) {
          contactFiltered.isCheckedForView = action.payload.isChecked; // Update the `isChecked` status
        }

      },
      setCurrentProjectTenderDetail : (state, action: PayloadAction<ProjectTenderDetailInterface>) => {
    
        const mappedList = state.sharedContacttDetailList.map((contact) => {
          // Find the matching shared contact by ID
          const sharedContact = action.payload.share_contact.find((shared) => shared.id === contact.id);
        
          // Update the fields if there's a match
          if (sharedContact) {
            return {
              ...contact,
              isCheckedForEdit: sharedContact.can_edit === 1,
              isCheckedForView: sharedContact.can_view === 1,
              isCheckedForShare: contact.id === sharedContact.id, // Mark as shared since it exists in sharedContactList
            };
          } else{
            return {
              ...contact,
              isCheckedForEdit: false,
              isCheckedForView: false,
              isCheckedForShare: false, // Mark as shared since it exists in sharedContactList
            };
          }
        
         
        });

        state.sharedContacttDetailList = mappedList;
        state.filteredContacttDetailList = mappedList;

      },
      setTenderDocumentListForView : (state, action: PayloadAction<ProjectTenderDetailInterface>) => {
        state.currentProjectTenderPartId = action.payload.project_tender_part_id;

        const findTenderDet = state.projectTenderDetail.find((ten) => ten.project_tender_part_id === state.currentProjectTenderPartId);
            if(findTenderDet){
              state.tenderDocumentListForView =  findTenderDet.tender_document

            }


      },
      setSowCurrentTenderPart: (state,action: PayloadAction<ProjectTenderDetailInterface>) => {
        state.currentProjectTenderDetail = action.payload;
      },
      setContactListForComparePrice: (state,action: PayloadAction<TenderListInterface[]>) => {
        state.contactListForComparePrice = action.payload;
      },
      setCheckComparePriceContact : (state, action: PayloadAction<ShareContactDetailsPayload>) => {

        const contact = state.sharedContacttDetailList.find(
          (contact) => contact.id === action.payload.id
        );
        if (contact) {
          contact.isCheckedForShare = action.payload.isChecked; // Update the `isChecked` status

          if(!action.payload.isChecked){
            contact.isCheckedForEdit = false;
            contact.isCheckedForView = false;
          }
        }

      },
    },
    extraReducers(builder){
        builder.addCase(getProjectTenderDetailList.rejected, (state, action) => {
            state.loadingProjectTenderDetail = false;
            state.errorProjectTenderDetail = action.error.message!;
          })
            .addCase(getProjectTenderDetailList.pending, state => {
            state.loadingProjectTenderDetail = true;
            state.errorProjectTenderDetail = null;
          })
          .addCase(getProjectTenderDetailList.fulfilled, (state, action: PayloadAction<ProjectTenderDetailInterface[]>) => {
            state.loadingProjectTenderDetail = false;
            state.projectTenderDetail = action.payload;

            const findTenderDet = state.projectTenderDetail.find((ten) => ten.project_tender_part_id === state.currentProjectTenderPartId);
            if(findTenderDet){
              state.tenderDocumentListForView =  findTenderDet.tender_document

            }

            if(state.currentProjectTenderDetail){
              const filteredTenderDet = state.projectTenderDetail.filter((ten) => ten.project_tender_part_id === state.currentProjectTenderDetail?.project_tender_part_id);

              if(filteredTenderDet){
                state.currentProjectTenderDetail = filteredTenderDet[0];
              }

            }
            
          })
          //Get all tender sow
          .addCase(getProjectTenderSowTemplateList.rejected, (state, action) => {
            state.loadingProjectTenderSow = false;
            state.errorProjectTenderSow = action.error.message!;
          })
            .addCase(getProjectTenderSowTemplateList.pending, state => {
            state.loadingProjectTenderSow = true;
            state.errorProjectTenderSow = null;
          })
          .addCase(getProjectTenderSowTemplateList.fulfilled, (state, action: PayloadAction<TenderSow[]>) => {
            state.loadingProjectTenderSow = false;
            state.tenderSowTemplateList = action.payload;
          })
          //tender sow section and Priliminary
          .addCase(getSowSectionAndPriliminary.rejected, (state, action) => {
            state.loadingViewSowSectionAndPriliminary = false;
            state.errorViewSowSectionAndPriliminary = action.error.message!;
          })
            .addCase(getSowSectionAndPriliminary.pending, state => {
            state.loadingViewSowSectionAndPriliminary = true;
            state.errorViewSowSectionAndPriliminary = null;
          })
          .addCase(getSowSectionAndPriliminary.fulfilled, (state, action: PayloadAction<SectionAndPriliminaryType>) => {
            state.loadingViewSowSectionAndPriliminary = false;
            state.viewSowSection = action.payload.sowSection;
            state.viewSowPriliminary = action.payload.priliminary;
            
          })
          //tender sow section
          .addCase(getSowSectionData.rejected, (state, action) => {
            state.loadingViewSowSection = false;
            state.errorViewSowSection = action.error.message!;
          })
            .addCase(getSowSectionData.pending, state => {
            state.loadingViewSowSection = true;
            state.errorViewSowSection = null;
          })
          .addCase(getSowSectionData.fulfilled, (state, action: PayloadAction<SowSection[]>) => {
            state.loadingViewSowSection = false;
            state.viewSowSection = action.payload;
            
          })
          //tender sow Priliminary
          .addCase(getSowPriliminaryData.rejected, (state, action) => {
            state.loadingViewSowPriliminary = false;
            state.errorViewSowPriliminary = action.error.message!;
          })
            .addCase(getSowPriliminaryData.pending, state => {
            state.loadingViewSowPriliminary = true;
            state.errorViewSowPriliminary = null;
          })
          .addCase(getSowPriliminaryData.fulfilled, (state, action: PayloadAction<Priliminary[]>) => {
            state.loadingViewSowPriliminary = false;
            state.viewSowPriliminary = action.payload;
            
          })
    }

})



export const {setSharedContactDetails,setFilterContact, setCheckSharedContact, setCheckSharedContactEdit, setCheckSharedContactView, setCurrentProjectTenderDetail, setTenderDocumentListForView, setSowCurrentTenderPart, setContactListForComparePrice} = tenderSlice.actions
export default tenderSlice.reducer